import { createContext, useContext } from 'react';

export const WizardContext = createContext({});
export const useWizardContext = () => useContext(WizardContext);
